import React from 'react'
import Image from '../../../images/buyerpolicies/Contact.png'

const Contact = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Contact</h2>
            <p>If you have any query or confusion about this, you can send us an email at <a href='mailto:help@kaay.pk'>help@kaay.pk</a> You can also call at 03 111 777 566</p>
        </div>
      </div>
    </div>
  )
}

export default Contact
